import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Response =
  | { errors: Error[] }
  | {
      generatePortfolioLinkAccessToken: {
        accessToken: string;
        portfolioId: string;
        provider: string;
      };
    };

export const getQueryKey = (providerName: string) =>
  ['PORTFOLIO_LINK_ACCESS_TOKEN', providerName] as const;

export const queryFn = async ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof getQueryKey>>) => {
  const [, providerName] = queryKey;
  const response = await requestWithAuth<Response>(
    gql`
      mutation generatePortfolioLinkAccessToken($provider: String!) {
        generatePortfolioLinkAccessToken(provider: $provider) {
          portfolioId
          accessToken
          provider
        }
      }
    `,
    {
      provider: providerName,
    }
  );
  if ('generatePortfolioLinkAccessToken' in response) {
    return response.generatePortfolioLinkAccessToken;
  }

  const [firstError] = response.errors;

  throw new Error(
    firstError?.message ?? 'Failed to generatePortfolioLinkAccessToken'
  );
};
